import { atom } from 'recoil';
const loadingState = atom<string[]>({
  key: 'loading',
  default: []
});
export default loadingState;